import { useRef, useState, useCallback } from "react";

import { UseVideoPlayerReturn } from "./types";

/**
 * Custom hook for managing video player state
 *
 * @returns Object containing videoRef, isPlaying state, and event handlers
 *
 * @example
 * ```tsx
 * const { videoRef, isPlaying, handlePlay, handlePause, handleEnded } = useVideoPlayer();
 * return <Video ref={videoRef} onPlay={handlePlay} onPause={handlePause} onEnded={handleEnded} />;
 * ```
 */
const useVideoPlayer = (): UseVideoPlayerReturn => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const handlePlay = useCallback(() => setIsPlaying(true), []);
  const handlePause = useCallback(() => setIsPlaying(false), []);
  const handleEnded = useCallback(() => setIsPlaying(false), []);

  return { videoRef, isPlaying, handlePlay, handlePause, handleEnded };
};

export { useVideoPlayer };
